import { ChevronLeft, ChevronRight } from "lucide-react";
import { cn } from "@/lib/utils";

/**
 * The marks that say where something leads: into a page, back to the one above
 * it, or the next step down the header's trail.
 *
 * One module, because a right chevron elsewhere means a panel that folds, and
 * the disclosure rule holds every other file to that. These never turn: they
 * point where a link goes, and say nothing about anything opening.
 */
export function GoesTo({ className }: { className?: string }) {
  return (
    <ChevronRight
      aria-hidden
      className={cn("size-[17px] shrink-0 text-subtle-foreground", className)}
    />
  );
}

export function GoesBack() {
  return <ChevronLeft aria-hidden />;
}

export function TrailStep() {
  return (
    <ChevronRight aria-hidden className="size-3.5 shrink-0 text-white/40" />
  );
}
